<template>
  <nav class="navbar navbar-default navbar-fixed-top">
    <div class="container">
      <!-- Brand and toggle get grouped for better mobile display -->
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" href="#/home">
          <img src="../assets/home/logo.png" alt="logo" />
          <div class="logo-text-wrapper">
            <span class="logo-title">同慧信息科技</span>
            <span class="logo-subtitle">专注政府后勤信息服务</span>
          </div>
        </a>
      </div>
      <!-- Collect the nav links, forms, and other content for toggling -->
      <div class="collapse navbar-collapse navbar-right" id="bs-example-navbar-collapse-1">
        <ul class="nav navbar-nav">
          <li :class="$route.path === '/home' ? 'active' : ''">
            <a @click="handleClick('/home')">首页<span class="active-line"></span></a>
          </li>
          <li :class="$route.path === '/companyProfile' ? 'active' : ''">
            <a @click="handleClick('/companyProfile')">公司简介<span class="active-line"></span></a>
          </li>
          <li :class="$route.path.indexOf('productPresentation') >= 0 ? 'active' : ''">
            <a @click="handleClick('/productPresentation')">产品和解决方案<span class="active-line"></span></a>
          </li>
          <li :class="$route.path === '/services' ? 'active' : ''">
            <a @click="handleClick('/services')">服务领域<span class="active-line"></span></a>
          </li>
          <li :class="$route.path === '/contact' ? 'active' : ''">
            <a @click="handleClick('/contact')">联系我们<span class="active-line"></span></a>
          </li>
          <!-- <li :class="$route.path === '/afterSales' ? 'active' : ''">
            <a @click="handleClick('/afterSales')">售后服务<span class="active-line"></span></a>
          </li> -->
        </ul>
      </div>
      <!-- /.navbar-collapse -->
    </div>
    <!-- /.container-fluid -->
  </nav>
</template>
<script>
export default {
  methods: {
    handleClick(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>
<style scoped>
.logo-text-wrapper {
  display: none;
}
.navbar-default {
  background-color: #ffffff;
  border-color: #ffffff;
}
.navbar-brand {
  padding: 9px 15px;
  display: flex;
  align-items: center;
}
.navbar-nav > li > a {
  cursor: pointer;
}
@media (min-width: 768px) {
  .navbar-default .navbar-nav > li > a {
    color: #333333;
    font-weight: bold;
    border-left: 1px solid #ffffff;
    border-right: 1px solid #ffffff;
  }

  .navbar-default .navbar-nav > .active > a,
  .navbar-default .navbar-nav > .active > a:focus,
  .navbar-default .navbar-nav > .active > a:hover {
    background-color: #ffffff;
    border-left-color: #e2e2e2;
    border-right-color: #e2e2e2;
    color: #346bdc;
  }

  .active-line {
    width: 100%;
    height: 4px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #346bdc;
    display: none;
  }

  .navbar-default .navbar-nav > .active > a > .active-line,
  .navbar-default .navbar-nav > .active > a:focus > .active-line,
  .navbar-default .navbar-nav > .active > a:hover > .active-line {
    display: block;
  }
  .navbar-brand {
    padding: 4px 0;
    display: flex;
    align-items: center;
  }
  .logo-text-wrapper {
    display: flex;
    flex-direction: column;
    padding-top: 6px;
    margin-left: 8px;
  }
  .logo-title {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
  .logo-subtitle {
    font-size: 10px;
    font-weight: 400;
    color: #346bdc;
  }
}

.navbar-brand > img {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue